import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a flat 2.0 x 1.4 m area rug, 0.02 thick, in
// fabric blue-grey with a darker border frame laid on top.
const RUG = "#8a9aa8";
const BORDER = "#6f8090";

export const areaRug = defineModel({
  id: "area-rug",
  batchId: "modern",
  name: "Area rug",
  tags: ["modern", "interior", "decor", "rug", "living-room"],
  summary: "A flat blue-grey area rug with a darker border.",
  tiles: { w: 2, h: 2 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // rug body
      { geometry: new THREE.BoxGeometry(2.0, 0.02, 1.4), color: RUG, position: [0, 0.01, 0] },
      // darker border frame on top (four strips)
      { geometry: new THREE.BoxGeometry(2.0, 0.008, 0.1), color: BORDER, position: [0, 0.024, 0.65] },
      { geometry: new THREE.BoxGeometry(2.0, 0.008, 0.1), color: BORDER, position: [0, 0.024, -0.65] },
      { geometry: new THREE.BoxGeometry(0.1, 0.008, 1.2), color: BORDER, position: [0.95, 0.024, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.008, 1.2), color: BORDER, position: [-0.95, 0.024, 0] },
    ];
  },
  animations: [],
});
